import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { ContentComponent } from './content/content.component';
import { WorkerInfoComponent } from "./worker-info/worker-info.component";

const appRoutes: Routes = [
  { path: 'connect', component: LoginComponent },
  { path: 'content', component: ContentComponent },
  { path: 'worker', component: WorkerInfoComponent },
  { path: '', redirectTo: '/content', pathMatch: 'full' },
];

@NgModule({
  imports: [ RouterModule.forRoot(appRoutes) ],
  exports: [ RouterModule ]
})

export class AppRoutingModule {}
